import { useMemo } from 'react';

import type { Segment } from 'src/modules/homeownerApp/helpers/segmentation';

import { instancesToMaterials } from './helpers';

export const useSegmentMaterials = (segments: Segment[]) =>
  useMemo(() => instancesToMaterials(segments), [segments]);
